const ITEMS = ["Boundary", "ALTA/NSPS", "Topographic", "As-Built", "Subdivision Plats", "Utility Mapping", "Right-of-Way", "Point Cloud to CAD", "Drone Mapping", "GIS", "Hydrographic", "Data Conversion"];

export const Marquee = () => (
  <div data-testid="services-marquee" className="relative overflow-hidden border-y border-[#102A43]/10 bg-[#F3F6F8] py-8" aria-label="Survey drafting disciplines">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {ITEMS.map((t) => (
            <span key={t} className="flex items-center font-display text-4xl md:text-6xl font-extrabold tracking-tight text-[#102A43] px-8">
              {t}<span className="ml-16 inline-block h-3 w-3 rotate-45 border-2 border-[#D8B66A]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
